import { SelectedFile } from 'types/file'
import { Media } from 'types/media'

// Check whether a File-only key exists
export const isFile = (media: SelectedFile | Media | string): media is SelectedFile =>
  typeof media === 'object' && ('lastModified' in media || 'uri' in media || 'path' in media)
